import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/login/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
		redirect: '/home/company',
    component: () => import('../views/Home.vue'),
		meta: { requiresAuth: true },
		children: [
			{
				path: 'company',
				name: 'company',
				component: () => import('../views/Company.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'subcompany',
				name: 'subcompany',
				component: () => import('../views/SubCompany.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'position',
				name: 'position',
				component: () => import('../views/Position.vue'),
				meta: { requiresAuth: true }
			},
			{
				path: 'student',
				name: 'student',
				component: () => import('../views/Student.vue'),
				meta: { requiresAuth: true }
			}
		]
  },
	{
		path: '/',
		redirect: 'login',
		component: Login,
	},
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
